"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedFilterOptionsCount = void 0;
const react_instantsearch_1 = require("react-instantsearch");
const constants_1 = require("../../constants");
const useSelectedFilterOptionsCount = () => {
    const { items: selectedFilters } = (0, react_instantsearch_1.useCurrentRefinements)();
    const selectedFilterOptionsCount = selectedFilters.reduce((count, filter) => {
        if (filter.attribute.startsWith(`${constants_1.HIERARCHIES_KEY}.`)) {
            return count + String(filter.refinements[0].value).split(' > ').length; // Count each level in the hierarchy as a separate filter
        }
        return constants_1.EXCEPTIONAL_REFINEMENT_KEYS.has(filter.attribute)
            ? count
            : count + filter.refinements.length;
    }, 0);
    return selectedFilterOptionsCount;
};
exports.useSelectedFilterOptionsCount = useSelectedFilterOptionsCount;
